import firebase from 'firebase/app';
import 'firebase/firestore';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyBGPMadjlDiNl-T_5Nh7Osta_u9S5uBJ3c',
  authDomain: 'iamnorbertn.firebaseapp.com',
  databaseURL: 'https://iamnorbertn.firebaseio.com',
  projectId: 'iamnorbertn',
  storageBucket: 'iamnorbertn.appspot.com',
  messagingSenderId: '383130762963',
};
const firebaseAPP = firebase.initializeApp(config);
firebaseAPP.firestore().settings({
  timestampsInSnapshots: true,
});

// export the firestore database
export default firebaseAPP.firestore();
